"use strict";
exports.__esModule = true;
exports.update = void 0;
function update(base, updatePartial) {
    return Object.assign(base, updatePartial);
}
exports.update = update;
